import { useContext, useEffect } from 'react';
import dayjs from 'dayjs';
import { useMachine } from '@xstate/react';
import { DataAccessContext } from '@chargify/data-access';
import { cancelForm } from '../machines';
import { CancelOptions } from '../constants';

export const useCancelForm = (
  enabledChurnReasonCodes: boolean,
  availableCancelType: CancelOptions[]
) => {
  const defaultDate = dayjs().add(7, 'day');
  const { dataAccess } = useContext(DataAccessContext);
  const [{ context, value }, send] = useMachine(cancelForm, {
    context: {
      cancellationType: availableCancelType[0],
      cancellationDate: defaultDate.toISOString(),
    },
    services: {
      getChurnReasonCodes: () => {
        return dataAccess.getChurnReasonCodes();
      },
    },
  });

  useEffect(() => {
    if (enabledChurnReasonCodes) {
      send({ type: 'GET_CHURN_REASON_CODES' });
    }
  }, [enabledChurnReasonCodes, send]);

  const isLoading = value === 'loading';
  const hasError = value === 'error';
  const isFormValid = () => {
    if (context.cancellationConfirmation !== 'cancel') {
      return false;
    }
    if (enabledChurnReasonCodes && context.churnReasons.length > 0) {
      return context.cancellationChurnReasonCode !== null;
    }
    return true;
  };
  return {
    context,
    send,
    isValid: isFormValid(),
    isLoading,
    hasError,
  } as const;
};
